import React from "react";
import {
  BrowserRouter as Router,
  Redirect,
  Route,
  Switch
} from "react-router-dom";

import Order from "../views/Order";
import FinalPreview from "../views/FinalPreview";
import Preview from "../views/Preview";

export default class MyRouter extends React.Component {
  render() {
    const { order, isInCart, artistName, isOrderedDigital, variants } = this.props;
    return (
      <Router>
        <Switch>
          <Route
            path="/"
            render={() => (
              <Order
                order={order}
                isInCart={isInCart}
                artistName={artistName}
                isOrderedDigital={isOrderedDigital}
                variants={variants}
              />
            )}
          />
        </Switch>
      </Router>
    );
  }
}



// WEBPACK FOOTER //
// ./src/routes/Router.js